$('.crypto__card_active').hover((event) => {
    $(event.target.closest('.crypto__card')).addClass('crypto__card_show');
    setTimeout(function () {
        $(event.target.closest('.crypto__card')).removeClass('crypto__card_show');
    }, 400);
})
$('[data-showtab]').click(function(){
    const target = $(this).data('showtab');
    $(this).parent().find('.active').removeClass('active');
    $(this).addClass('active');
    $($(target).parent()).find('.d-block').removeClass('d-block');
    $(target).addClass('d-block');
})

function scrollToProductList() {
    const list = $('.prodtable:visible, .prodcards:visible')[0];

    if (list) list.scrollIntoView();
}

$('.header__viewall').click(scrollToProductList);

$(document).ready(function () {
    if (location.hash) scrollToProductList();
})
